import { version as reactVersion } from "react";

/**
 * react-dom 18 emits `inert=""` and drops `inert={true}`; the vendored 19
 * canary does the reverse — `react`/`react-dom` are aliased as a pair in every
 * runtime here, which is what makes React's own major a valid proxy (WAT-11671).
 */
export function inertSlotFor(version: string): { inert?: boolean } {
  // HTMLAttributes.inert is typed `boolean`; react-dom 18's empty-string form
  // cannot be spelled as one, hence the assertion. Unparseable version falls to 18.
  return Number.parseInt(version, 10) >= 19 ?
    { inert: true } :
    ({ inert: "" } as unknown as { inert?: boolean });
}

/** Spread to make a node inert; the absent case is spelled by not spreading it. */
export const INERT_SLOT: { inert?: boolean } = inertSlotFor(reactVersion);
